import Modal from 'LuxKit/Modal/Modal'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useMemo } from 'react'

interface TProps {
  remainingTime: {
    hours: number
    minutes: number
  }
}

function RemainingTimeModal({ remainingTime }: TProps) {
  const { hours, minutes } = remainingTime

  const remainingTimeCopy = useMemo(() => {
    if (hours > 0) {
      return pluralizeToString('hour', hours)
    }
    return pluralizeToString('minute', minutes)
  }, [hours, minutes])

  return (
    <Modal title="Cancellation protection">
      <BodyTextBlock variant="medium">
        You have {remainingTimeCopy} to add cancellation protection. After that, it’s no longer available—this limit is set by our partner, XCover.
      </BodyTextBlock>
    </Modal>
  )
}

export default RemainingTimeModal
